module.exports = __webpack_public_path__ + "img/icon_system_terminal_docker.ab4641b9.svg";